/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            path: '/pages/already-logedin',
            name: 'already-logedin',
            component: () => import('@/views/pages/AlreadyLogedin.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/access-denied',
            name: 'access-denied',
            component: () => import('@/views/pages/AccessDenied.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/login',
            name: 'page-login',
            component: () => import('@/views/pages/login/Login.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/register',
            name: 'page-register',
            component: () => import('@/views/pages/register/Register.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/forgot-password',
            name: 'page-forgot-password',
            component: () => import('@/views/pages/ForgotPassword.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/reset-password',
            name: 'page-reset-password',
            component: () => import('@/views/pages/ResetPassword.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/lock-screen',
            name: 'page-lock-screen',
            component: () => import('@/views/pages/LockScreen.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/comingsoon',
            name: 'page-coming-soon',
            component: () => import('@/views/pages/ComingSoon.vue'),
            meta: {
                rule: 'isOperator'
            }
        },
        {
            path: "*",
            redirect: '/pages/error-404'
        },
        {
            path: '/pages/error-404',
            name: 'page-error-404',
            component: () => import('@/views/pages/Error404.vue'),
            meta: {
                rule: 'isPublic'
            }
        },
        {
            path: '/pages/error-500',
            name: 'page-error-500',
            component: () => import('@/views/pages/Error500.vue'),
            meta: {
                rule: 'isOperator'
            }
        },
        {
            path: '/pages/not-authorized',
            name: 'page-not-authorized',
            component: () => import('@/views/pages/NotAuthorized.vue'),
            meta: {
                rule: 'isOperator'
            }
        },
        {
            path: '/pages/maintenance',
            name: 'page-maintenance',
            component: () => import('@/views/pages/Maintenance.vue'),
            meta: {
                rule: 'isOperator'
            }
        },

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [

                {
                    path: '/pages/contact-us',
                    name: 'contact-us',
                    component: () => import('@/views/pages/ContactUs.vue'),
                    meta: {
                        rule: 'mc'
                    }
                },

                // =============================================================================
                // Theme Routes
                // =============================================================================

                {
                    path: '/',
                    name: 'Home',
                    component: () => import('./views/Home.vue'),
                    meta: {
                        rule: 'mc',
                    }
                },
                {
                    path: '/consumer/home',
                    name: 'ConsumerHome',
                    component: () => import('./views/ConsumerHome.vue'),
                    meta: {
                        rule: 'mc',
                    }
                },
                {
                    path: '/merchant/home',
                    name: 'MerchantHome',
                    component: () => import('./views/MerchantHome.vue'),
                    meta: {
                        rule: 'mc',
                    }
                },
                // =============================================================================
                // BPAY ROUTES
                // =============================================================================

                {
                    path: '/bill/new-bill',
                    name: 'NewBill',
                    component: () => import('@/views/bpay/bill/NewBill.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'NewBill', active: true },
                        ],
                        pageTitle: 'NewBill',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/user-profile',
                    name: 'UserProfile',
                    component: () => import('@/views/bpay/profile/UserProfile.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'UserProfile', active: true },
                        ],
                        pageTitle: 'UserProfile',
                        rule: 'onlyConsumer'
                    },
                },
                {
                    path: '/bill/bill-bulk-import',
                    name: 'bill-bulk-import',
                    component: () => import('@/views/bpay/bill/BillBulkImport.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'ارسال قبض', active: true },
                        ],
                        pageTitle: 'ارسال قبض گروهی',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/bill/bills',
                    name: 'bills',
                    component: () => import('@/views/bpay/bill/Bills.vue'),
                    props: {
                        header: true,
                        content: true
                    },
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'قبض ها', active: true },
                        ],
                        pageTitle: 'قبض ها',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/bill/consumer-bills',
                    name: 'ConsumerSingleBills',
                    component: () => import('@/views/bpay/bill/ConsumerSingleBills.vue'),
                    props: {
                        header: true,
                        content: true
                    },
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'ConsumerSingleBills', active: true },
                        ],
                        pageTitle: 'ConsumerSingleBills',
                        rule: 'isConsumer'
                    },
                },
                {
                    path: '/bill/consumer-booklet',
                    name: 'ConsumerGroupBills',
                    component: () => import('@/views/bpay/bill/ConsumerGroupBills.vue'),
                    props: {
                        header: true,
                        content: true
                    },
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'ConsumerGroupBills', active: true },
                        ],
                        pageTitle: 'ConsumerGroupBills',
                        rule: 'isConsumer'
                    },
                },
                {
                    path: '/bill/bills',
                    name: 'Bills',
                    component: () => import('@/views/bpay/bill/Bills.vue'),
                    props: {
                        header: true,
                        content: true
                    },
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'قبض ها', active: true },
                        ],
                        pageTitle: 'قبض ها',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/bill/paid-bills',
                    name: 'paid-bills',
                    component: () => import('@/views/bpay/bill/PaidBills.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'خانه', url: '/' },
                            { title: 'قبض های پرداخت شده', active: true },
                        ],
                        pageTitle: 'قبض های پرداخت شده',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/bill/bill-receivers',
                    name: 'bill-receivers',
                    component: () => import('@/views/bpay/bill/BillReceivers.vue'),
                    props: {
                        header: true,
                        content: true
                    },
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'قبض ها', url: '/bill/bills' },
                            { title: 'BillReceivers', active: true },
                        ],
                        pageTitle: 'BillReceivers',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/bill/consumer-bill-receivers',
                    name: 'consumer-bill-receivers',
                    component: () => import('@/views/bpay/bill/ConsumerBillReceivers.vue'),
                    props: {
                        header: true,
                        content: true
                    },
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'دفترچه اقساط الکترونیک', url: '/bill/bills' },
                            { title: 'ConsumerBillReceivers', active: true },
                        ],
                        pageTitle: 'ConsumerBillReceivers',
                        rule: 'isConsumer'
                    },
                },
                {
                    path: '/transaction/CurrentMerchantTransactions',
                    name: 'CurrentMerchantTransactions',
                    component: () => import('@/views/bpay/transaction/CurrentMerchantTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transactions', active: true },
                        ],
                        pageTitle: 'Transactions',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/transaction/CurrentConsumerTransactions',
                    name: 'CurrentConsumerTransactions',
                    component: () => import('@/views/bpay/transaction/CurrentConsumerTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transactions', active: true },
                        ],
                        pageTitle: 'Transactions',
                        rule: 'onlyConsumer'
                    },
                },
                {
                    path: '/transaction/MerchantTransactions',
                    name: 'MerchantTransactions',
                    component: () => import('@/views/bpay/transaction/MerchantTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transactions', active: true },
                        ],
                        pageTitle: 'Transactions',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/transaction/ConsumerTransactions',
                    name: 'ConsumerTransactions',
                    component: () => import('@/views/bpay/transaction/ConsumerTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transactions', active: true },
                        ],
                        pageTitle: 'Transactions',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/transaction/SettlementTransactions',
                    name: 'SettlementTransactions',
                    component: () => import('@/views/bpay/transaction/SettlementTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transactions', active: true },
                        ],
                        pageTitle: 'Transactions',
                        rule: 'mo'
                    },
                },
                {
                    path: '/transaction/AllTransactions',
                    name: 'AllTransactions',
                    component: () => import('@/views/bpay/transaction/AllTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'AllTransactions', active: true },
                        ],
                        pageTitle: 'AllTransactions',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/transaction/user-transactions',
                    name: 'UserTransactions',
                    component: () => import('@/views/bpay/transaction/AllTransactions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'AllTransactions', active: true },
                        ],
                        pageTitle: 'AllTransactions',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/merchant/DraftMerchants',
                    name: 'DraftMerchants',
                    component: () => import('@/views/bpay/draft/DraftMerchants.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'DraftMerchants', active: true },
                        ],
                        pageTitle: 'DraftMerchants',
                        rule: 'isOperator'
                    },
                },

                {
                    path: '/merchant/merchants',
                    name: 'merchants',
                    component: () => import('@/views/bpay/merchant/Merchants.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Merchants', active: true },
                        ],
                        pageTitle: 'Merchants',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/merchant/gateways',
                    name: 'MerchantGateways',
                    component: () => import('@/views/bpay/merchant/Gateways.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Gateways', active: true },
                        ],
                        pageTitle: 'Gateways',
                        rule: 'oa'
                    },
                },
                {
                    path: '/gateways',
                    name: 'gateways',
                    component: () => import('@/views/bpay/merchant/Gateways.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Gateways', active: true },
                        ],
                        pageTitle: 'Gateways',
                        rule: 'isMerchant'
                    },
                },
                {
                    path: '/merchant/register-merchant',
                    name: 'RegisterMerchant',
                    component: () => import('@/views/bpay/draft/register/RegisterRequest.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'RegisterMerchant', active: true },
                        ],
                        pageTitle: 'RegisterMerchant',
                        rule: 'onlyConsumer'
                    },
                },
                {
                    path: '/commission/CommissionGroups',
                    name: 'CommissionGroups',
                    component: () => import('@/views/bpay/commission/CommissionGroups.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'CommissionGroups', active: true },
                        ],
                        pageTitle: 'CommissionGroups',
                        rule: 'isAdmin'
                    },
                },
                {
                    path: '/commission/Commissions',
                    name: 'Commissions',
                    component: () => import('@/views/bpay/commission/Commissions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'CommissionGroups', url: '/commission/CommissionGroups' },
                            { title: 'Commissions', active: true },
                        ],
                        pageTitle: 'Commissions',
                        rule: 'isAdmin'
                    },
                },
                {
                    path: '/custom-setting/CustomSettingGroups',
                    name: 'CustomSettingGroups',
                    component: () => import('@/views/bpay/custom-setting/CustomSettingGroups.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'CustomSettingGroups', active: true },
                        ],
                        pageTitle: 'CustomSettingGroups',
                        rule: 'isAdmin'
                    },
                },
                {
                    path: '/custom-setting/CustomSettings',
                    name: 'CustomSettings',
                    component: () => import('@/views/bpay/custom-setting/CustomSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'CustomSettingGroups', url: '/custom-setting/CustomSettingGroups' },
                            { title: 'CustomSettings', active: true },
                        ],
                        pageTitle: 'CustomSettings',
                        rule: 'isAdmin'
                    },
                },
                {
                    path: '/user/users',
                    name: 'users',
                    component: () => import('@/views/bpay/user/Users.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Users', active: true },
                        ],
                        pageTitle: 'Users',
                        rule: 'isAdmin'
                    },
                },




                {
                    path: '/promoter/promoters',
                    name: 'promoters',
                    component: () => import('@/views/bpay/promoter/Promoters.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Promoters', active: true },
                        ],
                        pageTitle: 'Promoters',
                        rule: 'isOperator'
                    },
                },



                {
                    path: '/promoter/home',
                    name: 'home',
                    component: () => import('@/views/bpay/promoter/Home.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Home', active: true },
                        ],
                        pageTitle: 'Home',
                        rule: 'isPromoter'
                    },
                },

                {
                    path: '/promoter/my-merchants',
                    name: 'MyMerchants',
                    component: () => import('@/views/bpay/promoter/Merchants.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Merchants', active: true },
                        ],
                        pageTitle: 'Merchants',
                        rule: 'isPromoter'
                    },
                },
                {
                    path: '/promoter/my-draft-merchants',
                    name: 'myDraftMerchants',
                    component: () => import('@/views/bpay/promoter/DraftMerchants.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'myDraftMerchants', active: true },
                        ],
                        pageTitle: 'myDraftMerchants',
                        rule: 'isPromoter'
                    },
                },

                {
                    path: '/promoter/merchants',
                    name: 'merchant',
                    component: () => import('@/views/bpay/promoter/Merchants.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Merchants', active: true },
                        ],
                        pageTitle: 'Merchants',
                        rule: 'isOperator'
                    },
                },

                {
                    path: '/promoter/draft-merchants',
                    name: 'DraftMerchants',
                    component: () => import('@/views/bpay/promoter/DraftMerchants.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'myDraftMerchants', active: true },
                        ],
                        pageTitle: 'myDraftMerchants',
                        rule: 'isOperator'
                    },
                },

                {
                    path: '/consumer/consumers',
                    name: 'Consumers',
                    component: () => import('@/views/bpay/consumer/Consumers.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Consumers', active: true },
                        ],
                        pageTitle: 'Consumers',
                        rule: 'oa'
                    },
                },
                {
                    path: '/user/roles',
                    name: 'roles',
                    component: () => import('@/views/bpay/user/Roles.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Roles', active: true },
                        ],
                        pageTitle: 'Roles',
                        rule: 'isAdmin'
                    },
                },
                {
                    path: '/support/tickets',
                    name: 'Tickets',
                    component: () => import('@/views/bpay/support/Tickets.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Tickets', active: true },
                        ],
                        pageTitle: 'Tickets',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/support/supporter-tickets',
                    name: 'SupporterTickets',
                    component: () => import('@/views/bpay/support/SupporterTickets.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'SupporterTickets', active: true },
                        ],
                        pageTitle: 'SupporterTickets',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/support/ticket-items',
                    name: 'TicketItems',
                    component: () => import('@/views/bpay/support/TicketItems.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Tickets', active: true },
                            { title: 'TicketItems', active: true },
                        ],
                        pageTitle: 'TicketItems',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/support/create-ticket',
                    name: 'CreateTicket',
                    component: () => import('@/views/bpay/support/CreateTicket.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Tickets', active: true },
                            { title: 'CreateTicket', active: true },
                        ],
                        pageTitle: 'CreateTicket',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/support/departments',
                    name: 'Departments',
                    component: () => import('@/views/bpay/support/Departments.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Departments', active: true },
                        ],
                        pageTitle: 'Departments',
                        rule: 'isOperator'
                    },
                },
                {
                    path: '/settlement/settlements',
                    name: 'Settlements',
                    component: () => import('@/views/bpay/settlement/Settlements.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settlements', active: true },
                        ],
                        pageTitle: 'Settlements',
                        rule: 'asm'
                    },
                },
                {
                    path: '/settlement/current-user-settlements',
                    name: 'CurrentUserSettlements',
                    component: () => import('@/views/bpay/settlement/CurrentUserSettlements.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settlements', active: true },
                        ],
                        pageTitle: 'Settlements',
                        rule: 'asm'
                    },
                },


                // =============================================================================
                // Application Routes
                // =============================================================================
                {
                    path: '/apps/todo',
                    redirect: '/apps/todo/all',
                    name: 'todo',
                },

                {
                    path: '/apps/eCommerce/item/',
                    redirect: '/apps/eCommerce/item/5546604',
                },


                // =============================================================================
                // UI ELEMENTS
                // =============================================================================


                // =============================================================================
                // COMPONENT ROUTES
                // =============================================================================



                // =============================================================================
                // FORMS
                // =============================================================================
                // =============================================================================
                // FORM ELEMENTS
                // =============================================================================


                // =============================================================================
                // Pages Routes
                // =============================================================================


                // =============================================================================
                // CHARTS & MAPS
                // =============================================================================




                // =============================================================================
                // EXTENSIONS
                // =============================================================================

            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================

                {
                    path: '/pages/already-logedin',
                    name: 'already-logedin',
                    component: () => import('@/views/pages/AlreadyLogedin.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/access-denied',
                    name: 'access-denied',
                    component: () => import('@/views/pages/AccessDenied.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/login',
                    name: 'login',
                    component: () => import('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () => import('@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/lock-screen',
                    name: 'page-lock-screen',
                    component: () => import('@/views/pages/LockScreen.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/comingsoon',
                    name: 'page-coming-soon',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'isOperator'
                    }
                },
                { path: '*', redirect:{name: 'page-error-404'} },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'isPublic'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'isOperator'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'isOperator'
                    }
                },
                {
                    path: '/pages/maintenance',
                    name: 'page-maintenance',
                    component: () => import('@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'isOperator'
                    }
                },

            ]
        },
    ],
})

router.afterEach(() => {
    // Remove initial loading
    // if (userInfo && userInfo.userRole&&(userInfo.userRole=="Merchant"||userInfo.userRole.includes("Merchant"))) {
    //     next("/pages/login");
    //   }


    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
    // if (to.meta.authRequired) {
    //     router.push({ path: '/pages/login', query: { to: to.path } })
    // }
    // If auth required, check login. If login fails redirect to login page
    // let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    //     if(!userInfo || !userInfo.userRole)
    //     {
    //         router.push({ path: '/pages/login', query: { to: to.path } })
    //       }
    return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });    

});

export default router
